var fn = function( obj ){
var __t,__p='';
__p+='precision mediump float;\n\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\n\nvarying vec2 vTexCoord;\n\nuniform vec4 uTransform; // scale XY, translate XY\n\n#define MARGINS .0156\n\nvoid main(void){\n\n  gl_Position = vec4( aPosition * uTransform.xy + uTransform.zw, 0.0, 1.0 );\n  vTexCoord = aTexCoord * (1.0-MARGINS*2.0) + MARGINS;\n  \n}';
return __p;
};
fn.toString=fn;
module.exports = fn;